import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalService } from '../core';
import { GlobalNamespace as _GlobalNS,  environment } from '../../environments/environment';
import { RelationshipPrivilege, Relationship, PrivilegeGroup, Privilege } from './models/UserRelationship';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class PrivilegeService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };
  constructor(private _http: HttpClient, private _global: GlobalService) { }

  // Logged in PersonId is used for this service, not passing personid param expicilty
  findByRelationship(relationship: Relationship[]): Observable<RelationshipPrivilege[]> {
    const api = (<any>_GlobalNS).api.user.relationshipPrivilegeByPerson;
    const params = new HttpParams().set('RelationshipId', relationship[0].Id.toString());
    return this._http.get<any>(`${api}`, {params}).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  findByRelationshipTypeID(relationshipTypeId: number): Observable<RelationshipPrivilege[]> {
    const api = (<any>_GlobalNS).api.partner.partnerTypePrivileges;
    const params = new HttpParams().set('RelationshipTypeId', relationshipTypeId.toString());
    return this._http.get<any>(`${api}`, {params}).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  /*
  return privilges based on Enabled or Not
  */
  findByStatus(privileges: Privilege[], enabled?: boolean ): Privilege[] {
    let filteredPrivileges: Privilege[] = [];
    if (privileges !== null && privileges !== undefined && privileges.length > 0) {
      filteredPrivileges = privileges.filter((privilegeFilter: Privilege) => privilegeFilter.Enabled === enabled);
    }
    return filteredPrivileges;
  }
  /*
  return privilgeGroups based on Enabled or Not
  */
  findGroupByStatus(privilegeGroups: PrivilegeGroup[], enabled?: boolean): PrivilegeGroup[] {
    let filteredPrivilegeGroups: PrivilegeGroup[] = [];
    if (privilegeGroups !== null && privilegeGroups !== undefined && privilegeGroups.length > 0) {
      filteredPrivilegeGroups = privilegeGroups.filter((privilegeGroupFilter: PrivilegeGroup) => privilegeGroupFilter.Enabled === enabled);
    }
    return filteredPrivilegeGroups;
  }
   /*
    Remove unwanted elements privilegeGroup for Save / Update user
  */
  privilegeGroupData(privilegeGroups: PrivilegeGroup[]): PrivilegeGroup[] {
    const privilegeGroupData: PrivilegeGroup[] = [];
    if (privilegeGroups !== undefined && privilegeGroups.length) {
      privilegeGroups.filter((privileGroupFilter: PrivilegeGroup) =>
        (privileGroupFilter.Enabled === undefined || privileGroupFilter.Enabled)).map((privileGroup: PrivilegeGroup) => {
          privilegeGroupData.push({
            CompanyGroupId: privileGroup.CompanyGroupId
            , GroupName: privileGroup.GroupName
            , Enabled: privileGroup.Enabled
            , Privileges: this.privilegeData(privileGroup.Privileges)
          });
      });
    }
    return privilegeGroupData;
  }
  /*
   remove unwanted elements privilege for Save / Update user
  */
  privilegeData(privileges: Privilege[]): Privilege[] {
    const formattedPrivileges: Privilege[] = [];
    if (privileges !== undefined && privileges.length) {
      privileges.filter((privilegeFilter: Privilege) => (privilegeFilter.Enabled === undefined || privilegeFilter.Enabled))
        .map((privilege: Privilege) => {
          formattedPrivileges.push({
            PrivilegeId: privilege.PrivilegeId
            , PrivilegeName: privilege.PrivilegeName
            , Enabled : privilege.Enabled
        });
      });
    }
    return formattedPrivileges;
  }

  /*
  get Privilges which are not part of Privilege Group
  */
  uniquePrivilege(privileges: Privilege[], privilegeGroups: PrivilegeGroup[]): Privilege[] {
    privileges = this.privilegeData(privileges);
    if (privilegeGroups.length) {
      privilegeGroups.map((privilegeGroup: PrivilegeGroup) => {
        privilegeGroup.Privileges.map((groupPrivilege: Privilege) => {
          privileges = privileges.filter((privilege: Privilege) => privilege.PrivilegeId !== groupPrivilege.PrivilegeId);
        });
      });
    }
    return privileges;
  }

}
